module.exports = __webpack_public_path__ + "static/media/aw.93142860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/aw.png
// module id = 1788
// module chunks = 0